import App from '@/App.vue'
import router from '@/router'
import i18n from '@/i18n'
import { createPinia } from 'pinia'
import { Lazyload, setToastDefaultOptions } from 'vant';
import { useSystemInfo } from '@/store'
import { persistedState } from '@/store/plugins/persist'

const app = createApp(App)

const pinia = createPinia()
pinia.use(persistedState)

app.use(pinia)
app.use(i18n)
app.use(router)
app.use(Lazyload);

app.config.errorHandler = (err, instance, info) => {
  console.error('errorHandler', err, instance, info)
}

setToastDefaultOptions({
  forbidClick: true,
  zIndex: 199
})

app.config.performance = true

const systemInfo = useSystemInfo()
systemInfo.$subscribe((_, state) => {
  i18n.global.locale = state.language as 'en' | 'pt'

  if (router.currentRoute.value.path !== '/maintain' && state.merchantConfig && state.merchantConfig.siteStatus != 'Normal') {
    router.replace('/maintain')
  }
})

systemInfo.init()
  .then(() => app.mount('#app'))
  .catch((e) => {
    showFailToast({
      iconSize: 30,
      message: "Failed to init, please try later",
      duration: 0,
      wordBreak: 'break-word'
    })

    document.body.classList.add('defaultBg')
    console.error('init error', e)
  })